import React, { FunctionComponent, Reducer, useEffect, useReducer, useState } from 'react'
import { ModalSchedulingAction, ModalSchedulingActions, ScheduleData } from '../ModalSchedulingActions'
import { MailSettingsInstance } from 'plugin-reports-maker/webapp/js/common/types/api/report'
import { ScheduleType } from './helper'
import { store } from './Const'

export enum ActionTypesState {
    ADD_COMPONENT = 'ADD',
    REMOVE_COMPONENT = 'REMOVE'
}

export interface ScheduleActionComponent<T> {
    Component: FunctionComponent<ModalSchedulingAction<T>>
    name: string
    type: ScheduleType
    iconFontawesome: string
    loadData: (scheduleData: ScheduleData) => Promise<T>
    submitData: (data: T, scheduleData: ScheduleData) => Promise<T>
}

interface ActionAddComponet<T> {
    type: ActionTypesState.ADD_COMPONENT
    data: ScheduleActionComponent<T>
}

interface ActionRemoveComponet {
    type: ActionTypesState.REMOVE_COMPONENT
    data: {
        name: string
    }
}

export type ActionTypesReducer = ActionRemoveComponet | ActionAddComponet<any>

export function sheduleReducer(state: ScheduleActionComponent<any>[], action: ActionTypesReducer) {
    switch (action.type) {
        case ActionTypesState.ADD_COMPONENT:
            if (state.findIndex(component => component?.name === action?.data?.name) > -1) {
                return state
            }
            return [...state, action.data]
        case ActionTypesState.REMOVE_COMPONENT:
            return state.filter(actionComponent => actionComponent?.name !== action.data?.name)
        default:
            return state
    }
}

export function SheduleActions({
    schedule,
    actionsComponents,
    dispatch,
    scheduleType
}: {
    schedule: MailSettingsInstance
    scheduleType: ScheduleType
    actionsComponents: ScheduleActionComponent<any>[]
    dispatch: React.Dispatch<ActionTypesReducer>
}) {
    const [focusComponent, setFocusComponent] = useState<ScheduleActionComponent<any>>()

    
    return (
        <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
            {focusComponent ? (
                <ModalSchedulingActions
                    title={focusComponent.name}
                    onHide={() => setFocusComponent(undefined)}
                    Content={focusComponent?.Component}
                    loadData={focusComponent?.loadData}
                    submitData={focusComponent?.submitData}
                    schedule={schedule}
                />
            ) : null}

            {actionsComponents
                .filter(({ type }) => type == scheduleType)
                .map(action => {
                    return (
                        <span
                            onClick={() => setFocusComponent(action)}
                            key={'action_' + action.name}
                            className={`rmScheduling--scheduleList__element--section--actions--actionEditIcon ${action?.iconFontawesome}`}
                        />
                    )
                })}
        </div>
    )
}

export function RegisterSheduleAction<T>(props: ScheduleActionComponent<T>) {
    store.dispatch({
        type: ActionTypesState.ADD_COMPONENT,
        data: props
    })
}

export function RemoveSheduleAction({ name }: { name: string }) {
    store.dispatch({
        type: ActionTypesState.REMOVE_COMPONENT,
        data: { name }
    })
}
